(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var headers = document.querySelectorAll('[data-intg-header]');
  headers.forEach(function (header) {
    var drawer = header.querySelector('[data-intg-drawer]');
    var openBtn = header.querySelector('[data-intg-open]');
    var closeBtn = header.querySelector('[data-intg-close]');
    if (!drawer || !openBtn) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-intellisys"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupHero(root) {
    if (root.__intgHero) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-intg-slide]'));
    if (slides.length === 0) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-intg-dot]'));
    var prevBtn = root.querySelector('[data-intg-prev]');
    var nextBtn = root.querySelector('[data-intg-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reduce;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var typeSpeed = parseInt(root.getAttribute('data-speed'), 10) || 76;
    var eraseSpeed = Math.max(20, Math.round(typeSpeed * 0.45));
    var loopSingle = root.getAttribute('data-loop') !== 'false' && slides.length === 1;
    var idx = 0, timer = null, typeTimer = null, paused = false;

    function typeIn(slide) {
      clearTimeout(typeTimer);
      var el = slide.querySelector('[data-intg-typed]');
      if (!el) return;
      var full = el.getAttribute('data-text') || '';
      if (reduce || full.length === 0) { el.textContent = full; return; }
      var ci = 0, deleting = false;
      el.textContent = '';
      function tick() {
        if (deleting) {
          ci -= 1; el.textContent = full.slice(0, ci);
          if (ci <= 0) { deleting = false; typeTimer = setTimeout(tick, 650); }
          else { typeTimer = setTimeout(tick, eraseSpeed); }
        } else {
          ci += 1; el.textContent = full.slice(0, ci);
          if (ci >= full.length) {
            if (loopSingle) { typeTimer = setTimeout(function () { deleting = true; tick(); }, 2600); }
          } else {
            typeTimer = setTimeout(tick, typeSpeed);
          }
        }
      }
      typeTimer = setTimeout(tick, 500);
    }

    function restartAssemble(slide) {
      if (slide.className.indexOf('intg-hero__slide--anim-assemble') === -1) return;
      var animated = slide.querySelectorAll('.intg-hero__ch, .intg-hero__dot');
      Array.prototype.forEach.call(animated, function (el) {
        el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
      });
    }
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      typeIn(slides[idx]);
      restartAssemble(slides[idx]);
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }
    function play() { if (!autoplay || paused) return; stop(); timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);

    root.__intgHero = {
      slides: slides,
      show: show,
      selectBlock: function (el) {
        paused = true; stop();
        var i = slides.indexOf(el);
        if (i < 0 && el.closest) { i = slides.indexOf(el.closest('[data-intg-slide]')); }
        if (i >= 0) show(i);
      },
      deselectBlock: function () { paused = false; play(); },
      teardown: function () { stop(); clearTimeout(typeTimer); }
    };

    show(0);
    play();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-intg-hero]').forEach(setupHero);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-intg-hero]') : null;
    if (root && root.__intgHero) { root.__intgHero.teardown(); root.__intgHero = null; }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('[data-intg-hero]') : null;
    if (root && root.__intgHero) root.__intgHero.selectBlock(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest ? e.target.closest('[data-intg-hero]') : null;
    if (root && root.__intgHero) root.__intgHero.deselectBlock();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intellisys-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('[data-intg-filter-toggle]');
  if (toggle) {
    var side = document.getElementById(toggle.getAttribute('aria-controls'));
    if (side) {
      var open = side.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    return;
  }
  var closer = e.target.closest('[data-intg-filter-close]');
  if (closer) {
    var panel = closer.closest('.intg-coll__side');
    if (panel) {
      panel.classList.remove('is-open');
      document.body.style.overflow = '';
      var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
    return;
  }
  var backdrop = e.target;
  if (backdrop.classList && backdrop.classList.contains('intg-coll__side') && backdrop.classList.contains('is-open')) {
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    var b = document.querySelector('[aria-controls="' + backdrop.id + '"]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('click', function (event) {
  var btn = event.target.closest && event.target.closest('[data-intg-quote-add]');
  if (!btn || !window.IntgQuote) return;
  window.IntgQuote.add({
    id: btn.dataset.id,
    title: btn.dataset.title,
    sku: btn.dataset.sku,
    price: parseInt(btn.dataset.price, 10) || 0,
    url: btn.dataset.url,
    image: btn.dataset.image,
    qty: 1
  });
  var lbl = btn.querySelector('.intg-coll__cta-lbl');
  if (lbl && !btn.dataset.busy) {
    var original = lbl.textContent;
    btn.dataset.busy = '1';
    btn.classList.add('is-added');
    lbl.textContent = btn.dataset.addedLabel || 'Aggiunto ✓';
    setTimeout(function () {
      lbl.textContent = original;
      btn.classList.remove('is-added');
      delete btn.dataset.busy;
    }, 1800);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-intellisys"] && !Shopify.designMode) return;
  try {
    
class IntgQty extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.intg-pdp__qty-input');
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-dir]');
      if (!button || !this.input) return;
      const step = parseInt(button.dataset.dir, 10);
      const min = parseInt(this.input.min || '1', 10);
      const current = parseInt(this.input.value, 10) || min;
      this.input.value = Math.max(min, current + step);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}
if (!customElements.get('intg-qty')) {
  customElements.define('intg-qty', IntgQty);
}

document.addEventListener('click', function (event) {
  var btn = event.target.closest && event.target.closest('[data-intg-quote-add]');
  if (!btn || !window.IntgQuote) return;
  var qtyInput = btn.dataset.qtyInput ? document.getElementById(btn.dataset.qtyInput) : null;
  var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  window.IntgQuote.add({
    id: btn.dataset.id,
    title: btn.dataset.title,
    sku: btn.dataset.sku,
    price: parseInt(btn.dataset.price, 10) || 0,
    url: btn.dataset.url,
    image: btn.dataset.image,
    qty: qty
  });
  var lbl = btn.querySelector('.intg-pdp__quote-lbl');
  if (lbl && !btn.dataset.busy) {
    var original = lbl.textContent;
    btn.dataset.busy = '1';
    btn.classList.add('is-added');
    lbl.textContent = btn.dataset.addedLabel || 'Aggiunto ✓';
    setTimeout(function () {
      lbl.textContent = original;
      btn.classList.remove('is-added');
      delete btn.dataset.busy;
    }, 1800);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-request"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-intg-qr-root]');
  if (!root || !window.IntgQuote) return;

  if (root.querySelector('[data-intg-qr-success]')) {
    window.IntgQuote.clear();
    return;
  }

  var labels = {
    remove: root.getAttribute('data-label-remove') || 'Rimuovi',
    decrease: root.getAttribute('data-label-decrease') || 'Diminuisci',
    increase: root.getAttribute('data-label-increase') || 'Aumenta'
  };

  var listEl = root.querySelector('[data-intg-qr-list]');
  var emptyEl = root.querySelector('[data-intg-qr-empty]');
  var panelEl = root.querySelector('[data-intg-qr-panel]');
  var payloadEl = root.querySelector('[data-intg-qr-payload]');
  var form = document.getElementById('intg-qr-form');
  if (!listEl) return;

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var parts = (cents / 100).toFixed(2).split('.');
    return '€ ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function makeRow(it) {
    var row = document.createElement('div');
    row.className = 'intg-qr__row';

    var thumb = document.createElement('div');
    thumb.className = 'intg-qr__thumb';
    if (it.image) { var img = document.createElement('img'); img.src = it.image; img.alt = ''; thumb.appendChild(img); }
    row.appendChild(thumb);

    var info = document.createElement('div');
    info.className = 'intg-qr__info';
    var code = document.createElement(it.url ? 'a' : 'span');
    code.className = 'intg-qr__code';
    if (it.url) code.href = it.url;
    code.textContent = it.title || it.sku || '';
    info.appendChild(code);
    if (it.sku) { var meta = document.createElement('div'); meta.className = 'intg-qr__meta'; meta.textContent = it.sku; info.appendChild(meta); }
    row.appendChild(info);

    var qty = document.createElement('div');
    qty.className = 'intg-qr__qty';
    var minus = document.createElement('button'); minus.type = 'button'; minus.setAttribute('aria-label', labels.decrease); minus.textContent = '−';
    var input = document.createElement('input'); input.type = 'number'; input.min = '1'; input.value = it.qty; input.inputMode = 'numeric';
    var plus = document.createElement('button'); plus.type = 'button'; plus.setAttribute('aria-label', labels.increase); plus.textContent = '+';
    minus.addEventListener('click', function () { window.IntgQuote.setQty(it.id, (parseInt(input.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { window.IntgQuote.setQty(it.id, (parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('change', function () { window.IntgQuote.setQty(it.id, parseInt(input.value, 10) || 1); });
    qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);
    row.appendChild(qty);

    var rm = document.createElement('button');
    rm.type = 'button'; rm.className = 'intg-qr__remove'; rm.setAttribute('aria-label', labels.remove);
    rm.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 6h18"></path><path d="M8 6V4h8v2"></path><path d="M6 6l1 14h10l1-14"></path></svg>';
    rm.addEventListener('click', function () { window.IntgQuote.remove(it.id); });
    row.appendChild(rm);

    return row;
  }

  // La notifica "Modulo di contatto" di Shopify NON è personalizzabile: stampa
  // una riga "Etichetta: valore" per ogni campo contact[...], nell'ordine in cui
  // stanno nel form, e ignora gli a capo dentro un valore.
  // Perciò ogni prodotto viaggia in un campo suo, così resta su una riga leggibile.
  var MAX_CAMPI = 40;

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function qtyOf(it) {
    return parseInt(it.qty, 10) || 1;
  }

  function describe(it) {
    var code = clean(it.sku);
    var title = clean(it.title);
    var parts = [];
    if (code) parts.push(code);
    if (title && title !== code) parts.push(title);
    if (parts.length === 0) parts.push('(articolo senza codice)');

    var qty = qtyOf(it);
    if (it.price) {
      parts.push(qty + ' × ' + money(it.price) + ' = ' + money(qty * it.price));
    } else {
      parts.push(qty + ' pz — prezzo da definire');
    }
    return parts.join(' — ');
  }

  function estimatedTotal(items) {
    var sum = 0;
    var incomplete = false;
    items.forEach(function (it) {
      if (it.price) sum += qtyOf(it) * it.price; else incomplete = true;
    });
    var label = money(sum) + ' (IVA esclusa)';
    return incomplete ? label + ', esclusi gli articoli senza prezzo' : label;
  }

  function summary(items) {
    var noun = items.length === 1 ? ' prodotto' : ' prodotti';
    return items.length + noun + ' · totale stimato ' + estimatedTotal(items);
  }

  function fields(items) {
    var out = [{ name: 'Riepilogo', value: summary(items) }];
    var pad = items.length > 9;
    items.slice(0, MAX_CAMPI).forEach(function (it, i) {
      var n = String(i + 1);
      if (pad && n.length < 2) n = '0' + n;
      out.push({ name: 'Prodotto ' + n, value: describe(it) });
    });
    if (items.length > MAX_CAMPI) {
      out.push({
        name: 'Altri prodotti',
        value: items.slice(MAX_CAMPI).map(describe).join('  ·  ')
      });
    }
    return out;
  }

  function render() {
    var items = window.IntgQuote.items();
    listEl.innerHTML = '';
    var empty = items.length === 0;
    if (emptyEl) emptyEl.hidden = !empty;
    if (panelEl) panelEl.hidden = empty;
    if (empty) return;
    items.forEach(function (it) { listEl.appendChild(makeRow(it)); });
    fillPayload(items);
  }

  function fillPayload(items) {
    if (!payloadEl) return;
    payloadEl.innerHTML = '';
    fields(items).forEach(function (f) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + f.name + ']';
      input.value = f.value;
      payloadEl.appendChild(input);
    });
  }

  window.IntgQuote.onChange(render);
  render();

  if (form) {
    form.addEventListener('submit', function (e) {
      var items = window.IntgQuote.items();
      if (items.length === 0) { e.preventDefault(); return; }
      fillPayload(items);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
